type CityList = Record<string, { slug: string; name: string }[]>

const CANADA: CityList = {
  AB: [
    { slug: 'calgary', name: 'Calgary' },
    { slug: 'edmonton', name: 'Edmonton' },
    { slug: 'red-deer', name: 'Red Deer' }
  ],
  BC: [
    { slug: 'vancouver', name: 'Vancouver' },
    { slug: 'surrey', name: 'Surrey' },
    { slug: 'burnaby', name: 'Burnaby' }
  ],
  MB: [
    { slug: 'winnipeg', name: 'Winnipeg' },
    { slug: 'brandon-mb', name: 'Brandon' },
    { slug: 'steinbach', name: 'Steinbach' }
  ],
  NB: [
    { slug: 'saint-john-nb', name: 'Saint John' },
    { slug: 'moncton', name: 'Moncton' },
    { slug: 'fredericton', name: 'Fredericton' }
  ],
  NL: [
    { slug: 'st-johns', name: "St. John's" },
    { slug: 'mount-pearl', name: 'Mount Pearl' },
    { slug: 'corner-brook', name: 'Corner Brook' }
  ],
  NS: [
    { slug: 'halifax', name: 'Halifax' },
    { slug: 'dartmouth', name: 'Dartmouth' },
    { slug: 'sydney', name: 'Sydney' }
  ],
  ON: [
    { slug: 'toronto', name: 'Toronto' },
    { slug: 'ottawa', name: 'Ottawa' },
    { slug: 'mississauga', name: 'Mississauga' }
  ],
  PE: [
    { slug: 'charlottetown', name: 'Charlottetown' },
    { slug: 'summerside-pe', name: 'Summerside' },
    { slug: 'stratford', name: 'Stratford' }
  ],
  QC: [
    { slug: 'montreal', name: 'Montreal' },
    { slug: 'quebec-city', name: 'Quebec City' },
    { slug: 'laval', name: 'Laval' }
  ],
  SK: [
    { slug: 'saskatoon', name: 'Saskatoon' },
    { slug: 'regina', name: 'Regina' },
    { slug: 'prince-albert', name: 'Prince Albert' }
  ]
}

const USA: CityList = {
  AL: [
    { slug: 'birmingham-al', name: 'Birmingham' },
    { slug: 'montgomery-al', name: 'Montgomery' },
    { slug: 'mobile', name: 'Mobile' }
  ],
  AK: [
    { slug: 'anchorage-ak', name: 'Anchorage' },
    { slug: 'fairbanks', name: 'Fairbanks' },
    { slug: 'juneau-ak', name: 'Juneau' }
  ],
  AZ: [
    { slug: 'phoenix-az', name: 'Phoenix' },
    { slug: 'tucson', name: 'Tucson' },
    { slug: 'mesa', name: 'Mesa' }
  ],
  AR: [
    { slug: 'little-rock-ar', name: 'Little Rock' },
    { slug: 'fort-smith-ar', name: 'Fort Smith' },
    { slug: 'fayetteville-ar', name: 'Fayetteville' }
  ],
  CA: [
    { slug: 'los-angeles', name: 'Los Angeles' },
    { slug: 'san-diego-ca', name: 'San Diego' },
    { slug: 'san-jose', name: 'San Jose' }
  ],
  CO: [
    { slug: 'denver-co', name: 'Denver' },
    { slug: 'colorado-springs', name: 'Colorado Springs' },
    { slug: 'aurora-co', name: 'Aurora' }
  ],
  CT: [
    { slug: 'bridgeport-ct', name: 'Bridgeport' },
    { slug: 'new-haven-ct', name: 'New Haven' },
    { slug: 'stamford-ct', name: 'Stamford' }
  ],
  DC: [
    { slug: 'washington-dc', name: 'Washington' },
    { slug: 'arlington-va', name: 'Arlington' },
    { slug: 'alexandria-va', name: 'Alexandria' }
  ],
  DE: [
    { slug: 'wilmington-de', name: 'Wilmington' },
    { slug: 'dover-de', name: 'Dover' },
    { slug: 'newark-de', name: 'Newark' }
  ],
  FL: [
    { slug: 'jacksonville-fl', name: 'Jacksonville' },
    { slug: 'miami-fl', name: 'Miami' },
    { slug: 'tampa', name: 'Tampa' }
  ],
  GA: [
    { slug: 'atlanta-ga', name: 'Atlanta' },
    { slug: 'augusta-ga', name: 'Augusta' },
    { slug: 'columbus-ga', name: 'Columbus' }
  ],
  HI: [
    { slug: 'honolulu', name: 'Honolulu' },
    { slug: 'hilo', name: 'Hilo' },
    { slug: 'kailua', name: 'Kailua' }
  ],
  ID: [
    { slug: 'boise', name: 'Boise' },
    { slug: 'meridian-id', name: 'Meridian' },
    { slug: 'nampa', name: 'Nampa' }
  ],
  IL: [
    { slug: 'chicago', name: 'Chicago' },
    { slug: 'aurora-il', name: 'Aurora' },
    { slug: 'rockford-il', name: 'Rockford' }
  ],
  IN: [
    { slug: 'indianapolis', name: 'Indianapolis' },
    { slug: 'fort-wayne', name: 'Fort Wayne' },
    { slug: 'evansville-in', name: 'Evansville' }
  ],
  IA: [
    { slug: 'des-moines-ia', name: 'Des Moines' },
    { slug: 'cedar-rapids', name: 'Cedar Rapids' },
    { slug: 'davenport-ia', name: 'Davenport' }
  ],
  KS: [
    { slug: 'wichita', name: 'Wichita' },
    { slug: 'overland-park', name: 'Overland Park' },
    { slug: 'kansas-city-ks', name: 'Kansas City' }
  ],
  KY: [
    { slug: 'louisville-ky', name: 'Louisville' },
    { slug: 'lexington-ky', name: 'Lexington' },
    { slug: 'bowling-green-ky', name: 'Bowling Green' }
  ],
  LA: [
    { slug: 'new-orleans', name: 'New Orleans' },
    { slug: 'baton-rouge', name: 'Baton Rouge' },
    { slug: 'shreveport', name: 'Shreveport' }
  ],
  ME: [
    { slug: 'portland-me', name: 'Portland' },
    { slug: 'lewiston-me', name: 'Lewiston' },
    { slug: 'bangor-me', name: 'Bangor' }
  ],
  MD: [
    { slug: 'baltimore-md', name: 'Baltimore' },
    { slug: 'frederick-md', name: 'Frederick' },
    { slug: 'rockville-md', name: 'Rockville' }
  ],
  MA: [
    { slug: 'boston-ma', name: 'Boston' },
    { slug: 'worcester-ma', name: 'Worcester' },
    { slug: 'springfield-ma', name: 'Springfield' }
  ],
  MI: [
    { slug: 'detroit', name: 'Detroit' },
    { slug: 'grand-rapids-mi', name: 'Grand Rapids' },
    { slug: 'warren-mi', name: 'Warren' }
  ],
  MN: [
    { slug: 'minneapolis-mn', name: 'Minneapolis' },
    { slug: 'saint-paul-mn', name: 'Saint Paul' },
    { slug: 'rochester-mn', name: 'Rochester' }
  ],
  MS: [
    { slug: 'jackson', name: 'Jackson' },
    { slug: 'gulfport', name: 'Gulfport' },
    { slug: 'southaven', name: 'Southaven' }
  ],
  MO: [
    { slug: 'kansas-city', name: 'Kansas City' },
    { slug: 'st-louis', name: 'St. Louis' },
    { slug: 'springfield-mo', name: 'Springfield' }
  ],
  MT: [
    { slug: 'billings-mt', name: 'Billings' },
    { slug: 'missoula', name: 'Missoula' },
    { slug: 'great-falls-mt', name: 'Great Falls' }
  ],
  NE: [
    { slug: 'omaha', name: 'Omaha' },
    { slug: 'lincoln-ne', name: 'Lincoln' },
    { slug: 'bellevue-ne', name: 'Bellevue' }
  ],
  NV: [
    { slug: 'las-vegas-nv', name: 'Las Vegas' },
    { slug: 'henderson-nv', name: 'Henderson' },
    { slug: 'reno-nv', name: 'Reno' }
  ],
  NH: [
    { slug: 'manchester-nh', name: 'Manchester' },
    { slug: 'nashua-nh', name: 'Nashua' },
    { slug: 'concord-nh', name: 'Concord' }
  ],
  NJ: [
    { slug: 'newark-nj', name: 'Newark' },
    { slug: 'jersey-city', name: 'Jersey City' },
    { slug: 'paterson', name: 'Paterson' }
  ],
  NM: [
    { slug: 'albuquerque', name: 'Albuquerque' },
    { slug: 'las-cruces', name: 'Las Cruces' },
    { slug: 'rio-rancho', name: 'Rio Rancho' }
  ],
  NY: [
    { slug: 'new-york-city', name: 'New York City' },
    { slug: 'buffalo-ny', name: 'Buffalo' },
    { slug: 'rochester-ny', name: 'Rochester' }
  ],
  NC: [
    { slug: 'charlotte-nc', name: 'Charlotte' },
    { slug: 'raleigh-nc', name: 'Raleigh' },
    { slug: 'greensboro-nc', name: 'Greensboro' }
  ],
  ND: [
    { slug: 'fargo', name: 'Fargo' },
    { slug: 'bismarck-nd', name: 'Bismarck' },
    { slug: 'grand-forks-nd', name: 'Grand Forks' }
  ],
  OH: [
    { slug: 'columbus-oh', name: 'Columbus' },
    { slug: 'cleveland-oh', name: 'Cleveland' },
    { slug: 'cincinnati', name: 'Cincinnati' }
  ],
  OK: [
    { slug: 'oklahoma-city', name: 'Oklahoma City' },
    { slug: 'tulsa', name: 'Tulsa' },
    { slug: 'norman', name: 'Norman' }
  ],
  OR: [
    { slug: 'portland-or', name: 'Portland' },
    { slug: 'salem-or', name: 'Salem' },
    { slug: 'eugene', name: 'Eugene' }
  ],
  PA: [
    { slug: 'philadelphia-pa', name: 'Philadelphia' },
    { slug: 'pittsburgh', name: 'Pittsburgh' },
    { slug: 'allentown-pa', name: 'Allentown' }
  ],
  PR: [
    { slug: 'san-juan-pr', name: 'San Juan' },
    { slug: 'bayamon', name: 'Bayamón' },
    { slug: 'carolina', name: 'Carolina' }
  ],
  RI: [
    { slug: 'providence-ri', name: 'Providence' },
    { slug: 'warwick-ri', name: 'Warwick' },
    { slug: 'cranston', name: 'Cranston' }
  ],
  SC: [
    { slug: 'charleston-sc', name: 'Charleston' },
    { slug: 'columbia-sc', name: 'Columbia' },
    { slug: 'north-charleston', name: 'North Charleston' }
  ],
  SD: [
    { slug: 'sioux-falls', name: 'Sioux Falls' },
    { slug: 'rapid-city-sd', name: 'Rapid City' },
    { slug: 'aberdeen-sd', name: 'Aberdeen' }
  ],
  TN: [
    { slug: 'memphis-tn', name: 'Memphis' },
    { slug: 'nashville-tn', name: 'Nashville' },
    { slug: 'knoxville-tn', name: 'Knoxville' }
  ],
  TX: [
    { slug: 'houston-tx', name: 'Houston' },
    { slug: 'san-antonio-tx', name: 'San Antonio' },
    { slug: 'dallas-tx', name: 'Dallas' }
  ],
  UT: [
    { slug: 'salt-lake-city', name: 'Salt Lake City' },
    { slug: 'west-valley-city', name: 'West Valley City' },
    { slug: 'provo', name: 'Provo' }
  ],
  VT: [
    { slug: 'burlington-vt', name: 'Burlington' },
    { slug: 'south-burlington', name: 'South Burlington' },
    { slug: 'rutland-vt', name: 'Rutland' }
  ],
  VA: [
    { slug: 'virginia-beach', name: 'Virginia Beach' },
    { slug: 'norfolk-va', name: 'Norfolk' },
    { slug: 'chesapeake-va', name: 'Chesapeake' }
  ],
  WA: [
    { slug: 'seattle', name: 'Seattle' },
    { slug: 'spokane', name: 'Spokane' },
    { slug: 'tacoma', name: 'Tacoma' }
  ],
  WV: [
    { slug: 'charleston-wv', name: 'Charleston' },
    { slug: 'huntington-wv', name: 'Huntington' },
    { slug: 'parkersburg-wv', name: 'Parkersburg' }
  ],
  WI: [
    { slug: 'milwaukee', name: 'Milwaukee' },
    { slug: 'madison-wv', name: 'Madison' },
    { slug: 'green-bay', name: 'Green Bay' }
  ],
  WY: [
    { slug: 'cheyenne-wy', name: 'Cheyenne' },
    { slug: 'casper', name: 'Casper' },
    { slug: 'laramie', name: 'Laramie' }
  ]
}

const CITIES: CityList = {
  ...CANADA,
  ...USA
}

const usFallback = [
  { slug: 'seattle', name: 'Seattle' },
  { slug: 'new-york-city', name: 'New York City' },
  { slug: 'san-francisco', name: 'San Francisco' },
  { slug: 'austin-tx', name: 'Austin' }
]

const caFallback = [
  { slug: 'vancouver', name: 'Vancouver' },
  { slug: 'toronto', name: 'Toronto' },
  { slug: 'montreal', name: 'Montreal' },
  { slug: 'calgary', name: 'Calgary' }
]

const usePopularCities = (state: string, country: string) => {
  const fallback = country === 'US' ? usFallback : caFallback
  if (state) {
    const cities = CITIES[state.toUpperCase()]
    return cities ?? fallback
  }
  return fallback
}

export default usePopularCities
